import GyratoryCrusherCG from './GyratoryCrusherCG.png';
import GyratoryCrusherCGWithGrizzly from './GyratoryCrusherCGWithGrizzly.png';
import GyratoryCrusherBW from '../../Generic/GenericCrusher/images/GyratoryCrusherBW.png';
import GyratoryCrusherCG2 from './GyratoryCrusherCG_2.png';
import GyratoryCrusherCGWithGrizzly2 from './GyratoryCrusherCGWithGrizzly_2.png';

export const getImageGyratoryCrusherCG = (
  grizzly: boolean | undefined,
  showCustomModel: boolean | undefined,
) => {
  if (showCustomModel) {
    return GyratoryCrusherBW;
  } else if (grizzly) {
    return GyratoryCrusherCGWithGrizzly;
  } else {
    return GyratoryCrusherCG;
  }
};

export const getImageGyratoryCrusherCG2 = (
  grizzly: boolean,
  showCustomModel: boolean,
) => {
  if (showCustomModel) {
    return GyratoryCrusherBW;
  } else if (grizzly) {
    return GyratoryCrusherCGWithGrizzly2;
  } else {
    return GyratoryCrusherCG2;
  }
};
